/** Fill an array of `length` items by mapping each zero-based index. */
export function rangeMap<T>(length: number, fn: (index: number)=> T): T[] {
  return Array.from({ length }, (_, index)=> fn(index))
}